const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.FRIDGE_SLOTS)

export const apiFridgeSlots = {
	fetchClientFridgeStats: async (clientID: number) => {
		const { data } = await apiCommon<IClientFridgeStats>(`${groupPrefix}/${clientID}`, {
			method: 'GET',
		})
		return ClientFridgeStats(data)
	},

	fetchClientFridgeSlotsHistory: async (clientID: number, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IClientFridgeSlot[]>(`${groupPrefix}/${clientID}/history`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(ClientFridgeSlot), meta }
	},

	correctClientFridgeSlotsBalance: async (clientID: number, amount: number, comment?: string) => {
		const payload = {
			action: amount > 0 ? 'add' : 'decrease',
			amount: Math.abs(amount),
			comment,
		}

		const { data } = await apiCommon<IClientFridgeSlot>(`${groupPrefix}/${clientID}/adjustments`, {
			method: 'POST',
			body: payload,
		})

		return ClientFridgeSlot(data)
	},
}
